import Vue from 'vue';
import VueTour from 'vue-tour';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import store from './store';
import VueTagManager from "vue-tag-manager"
import axios from 'axios'

// Configurar axios para enviar cookies
axios.defaults.withCredentials = true;

// Do this before creating the Vue app
if( process.env.NODE_ENV === "production" ){
  console.log(process.env.NODE_ENV);
  Vue.use(VueTagManager, {
    gtmId: 'G-LEPLG67JZK'
  })
}

// Load Mouseflow only if VUE_APP_MOUSEFLOW_ID is set
if (process.env.VUE_APP_MOUSEFLOW_ID) {
  window._mfq = window._mfq || [];
  (function() {
    var mf = document.createElement('script');
    mf.type = 'text/javascript';
    mf.async = true;
    mf.src = '//cdn.mouseflow.com/projects/' + process.env.VUE_APP_MOUSEFLOW_ID + '.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(mf, s);
  })();
}


Vue.config.productionTip = false;

// CRITICAL FIX: Completely disable Vue DevTools BEFORE Vue initialization to prevent browser crashes
// This must happen before any Vue components are created
Vue.config.devtools = false;

// Disable DevTools in all environments (not just development)
try {
  // Delete the hook entirely if it exists
  if (window.__VUE_DEVTOOLS_GLOBAL_HOOK__) {
    delete window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
  }
  
  // Prevent DevTools from being installed
  Object.defineProperty(window, '__VUE_DEVTOOLS_GLOBAL_HOOK__', {
    value: {
      on: function() { return; },
      emit: function() { return; },
      off: function() { return; },
      once: function() { return; },
      Vue: null,
      apps: [],
      store: null
    },
    writable: false,
    configurable: false,
    enumerable: false
  });
  
  // Additional protection: prevent DevTools extension from injecting
  if (typeof window !== 'undefined') {
    window.__VUE_DEVTOOLS_DISABLED__ = true;
  }
  
  // Check for Chrome extensions that might interfere
  if (process.env.NODE_ENV === 'development') {
    setTimeout(() => {
      const hasVueDevTools = document.querySelector('script[src*="vue-devtools"]') || 
                            (window.__VUE_DEVTOOLS_GLOBAL_HOOK__ && window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue);
      if (hasVueDevTools) {
        console.warn('⚠️ Vue DevTools detected! This may cause performance issues. Consider disabling the extension.');
      }
      
      if (navigator.userAgent.includes('Chrome')) {
        console.info('💡 Tip: If experiencing performance issues in Chrome, try:');
        console.info('   1. Disable browser extensions (especially DevTools extensions)');
        console.info('   2. Test in an Incognito window (extensions disabled by default)');
        console.info('   3. Check Chrome Task Manager (Shift+Esc) for high CPU usage');
      }
    }, 1000);
  }
} catch (e) {
  // Silently fail
}

new Vue({
  router,
  vuetify,
  store,
  VueTour,
  render: (h) => h(App),
}).$mount('#app');
